module.exports = __webpack_public_path__ + "img/ebay.48a173c9.png";